import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import orderDeliveryWindowsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity";
import { ICreateOrderDelivery } from "app/modules/components/business-partners/business-partner/business-partner-order-modal/interfaces/create-business-partner-order.interface";
import { IUpdateOrderDelivery } from "app/modules/components/business-partners/business-partner/business-partner-order-modal/interfaces/update-business-partner-order.interface";
const apiUrl = env.API_MATERIAL_URL;
const moduleName = "material_group_delivery_windows";

@Injectable({
  providedIn: "root",
})
export class MaterialGroupOrderService extends AbstractService<
orderDeliveryWindowsAttributes,
ICreateOrderDelivery,
IUpdateOrderDelivery
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByMaterialGroupId(materialGroupId: string): Observable<IResult<orderDeliveryWindowsAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${materialGroupId}`;
    return this.http.get<IResult<orderDeliveryWindowsAttributes>>(API_URL);
  }
}